import { openBlock as c, createElementBlock as e, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, a = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  d: "M13.908 18.958H6.091c-3.475 0-4.533-1.058-4.533-4.533v-.383a.63.63 0 0 1 .625-.625c.733 0 1.333-.6 1.333-1.334 0-.733-.6-1.333-1.333-1.333a.63.63 0 0 1-.625-.625v-.383c0-3.475 1.058-4.534 4.533-4.534h7.817c3.475 0 4.533 1.059 4.533 4.534v.783a.63.63 0 0 1-.625.625c-.733 0-1.333.6-1.333 1.333 0 .734.6 1.325 1.333 1.325a.63.63 0 0 1 .625.625c-.008 3.467-1.066 4.525-4.533 4.525M2.816 14.592c.017 2.65.542 3.116 3.284 3.116h7.816c2.6 0 3.2-.425 3.275-2.733a2.58 2.58 0 0 1-1.95-2.5c0-1.208.834-2.225 1.959-2.508v-.234c0-2.791-.492-3.283-3.284-3.283H6.091c-2.733 0-3.258.475-3.283 3.117a2.591 2.591 0 0 1 .008 5.025"
}, null, -1), l = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  d: "M8.334 8.542a.63.63 0 0 1-.625-.625V5.833a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v2.084a.63.63 0 0 1-.625.625m0 5.558a.63.63 0 0 1-.625-.625V10.7a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v2.775a.63.63 0 0 1-.625.625m0 4.858a.63.63 0 0 1-.625-.625V16.25a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v2.083a.63.63 0 0 1-.625.625"
}, null, -1), n = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  d: "M13.608 6.458H6.033a.62.62 0 0 1-.575-.383.64.64 0 0 1 .133-.683L8.033 2.95C10.283.7 11.658.7 13.9 2.95l.5.5a.624.624 0 0 1 0 .883 1.11 1.11 0 0 0-.234 1.25.62.62 0 0 1-.041.6.62.62 0 0 1-.517.275m-6.067-1.25h5.275a2.33 2.33 0 0 1 .317-1.266l-.108-.109c-1.742-1.741-2.359-1.741-4.1 0z"
}, null, -1), r = [
  a,
  l,
  n
];
function s(h, i) {
  return c(), e("svg", o, [...r]);
}
const _ = { render: s };
export {
  _ as default,
  s as render
};
